import Vue from 'vue'
import Router from 'vue-router'
//登录页
import login from '@/views/login/login.vue'
//用户管理
import userList from '@/views/user/userList.vue' //用户列表
import userDetail from '@/views/user/detail.vue' //用户详情
import personalRecords from '@/views/user/personalRecords.vue' //个人查询记录
import credentialsAudit from '@/views/user/credentialsAudit.vue' //资质审核
import groupList from '@/views/user/groupManage/list.vue' //分组管理
//数据分析

import queryRecord from '@/views/dataAnalysis/queryRecord.vue' //查询记录
import commodityStore from '@/views/dataAnalysis/commodityStore.vue' //查询记录

//自动比价
import parityRecord from '@/views/automaticParity/parityRecord.vue' //自动比价记录
import databaseConnectionIfo from '@/views/automaticParity/databaseConnectionIfo.vue' //数据库连接信息
import lowPriceGoods from '@/views/automaticParity/lowPriceGoods.vue'//低价商品
import failRecord from '@/views/automaticParity/failRecord.vue' //比价失败记录

//网站导航
import navManage from '@/views/pcNavigation/pcNavigation2/navManage.vue' //导航管理
import navType from '@/views/pcNavigation/pcNavigation2/navType.vue' //导航分类

//用户建议
import platformSuggestions from '@/views/userSuggestions/platformSuggestions.vue' //平台建议
import commoditySuggestions from '@/views/userSuggestions/commoditySuggestions.vue' //平台建议
import softwareSuggestions from '@/views/userSuggestions/softwareSuggestions.vue' //软件建议
import errorBack from '@/views/userSuggestions/errorBack.vue' //错误反馈

//线下比价
import priceComparison from '@/views/priceComparison.vue' //线下比价

// 系统管理
import platformSupervise from '@/views/system/platformSupervise.vue' // 平台监管

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/login'},
    { path: '/priceComparison', name: '线下比价', component: priceComparison, meta: {keepAlive: false}},
    {path: '/login', name: '登录', component: login, meta: {keepAlive: false} },//登录页
    {path: '/userList', name: '用户', component: userList, meta: {keepAlive:false} },//用户列表
    {path: '/userList/detail', name: '用户/会员详情', component: userDetail, meta: {keepAlive: false} }, //用户详情
    {path: '/userList/personalRecords', name: '用户/查询记录', component: personalRecords, meta: {keepAlive: false} }, //个人查询记录
    {path: '/userList/credentialsAudit', name: '用户/资质审核', component: credentialsAudit, meta: {keepAlive: false} }, //资质审核
    {path: '/groupList', name: '分组管理', component: groupList, meta: {keepAlive:false} },//分组列表
    {path: '/queryRecord', name: '查询记录', component: queryRecord, meta: {keepAlive: false} }, //查询记录
    {path: '/commodityStore', name: '商品库', component: commodityStore, meta: {keepAlive: false} }, //商品库
    {path: '/platformSuggestions', name: '平台建议', component: platformSuggestions, meta: {keepAlive: false} }, //平台建议
    {path: '/commoditySuggestions', name: '商品建议', component: commoditySuggestions, meta: {keepAlive: false} }, //商品建议
    {path: '/softwareSuggestions', name: '软件建议', component: softwareSuggestions, meta: {keepAlive: false} }, //软件建议
    {path: '/errorBack', name: '错误反馈', component: errorBack, meta: {keepAlive: false} },//错误反馈
    /*自动比价 */
    {path: '/parityRecord', name: '比价记录', component: parityRecord, meta: {keepAlive: false} }, //比价记录
    {path: '/parityRecord/lowPriceGoods', name: '比价记录/低价商品', component: lowPriceGoods, meta: {keepAlive: false} }, //低价商品
    {path: '/parityRecord/failRecord', name: '比价记录/失败记录', component: failRecord, meta: {keepAlive: false} }, //失败记录
    {path: '/databaseConnectionIfo', name: '数据库连接信息', component: databaseConnectionIfo, meta: {keepAlive: false} }, //数据库连接信息

    {path: '/navManage', name: '导航管理', component: navManage, meta: {keepAlive: true} }, //导航管理
    {path: '/navType', name: '导航分类', component: navType, meta: {keepAlive: false} }, //导航分类

    // 系统管理
    {path: '/platformSupervise', name: '平台监管', component: platformSupervise, meta: {keepAlive: false} }, // 平台监管
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js